export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9607.21a81c2a.jpg";